import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Controller } from "react-hook-form";
import { IDaTextFieldProps } from "./types";

export type DaPasswordFieldProps = IDaTextFieldProps<any> & { showPasswordToggle?: boolean };

export const DaPasswordField: React.FC<DaPasswordFieldProps> = (
    {
        control,
        name,
        label,
        defaultValue = "",
        readOnly = false,
        required = false,
        size = "medium",
        variant = "standard",
        multiline = false,
        rows = 1,
        errors,
        showPasswordToggle = false,
    }: DaPasswordFieldProps
) => {
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => setShowPassword((prev) => !prev);

    const baseInputProps = readOnly ? { readOnly: true, className: "Mui-disabled" } : {};
    const endAdornment = showPasswordToggle ? (
        <InputAdornment position="end">
            <IconButton
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={toggleShowPassword}
                onMouseDown={(e) => e.preventDefault()}
                edge="end"
                size="small"
            >
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    ) : null;
    const inputProps = {
        ...baseInputProps,
        ...(endAdornment && { endAdornment }),
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <TextField
                    {...field}
                    label={required ? `${label} *` : label}
                    variant={variant}
                    size={size}
                    error={!!errors[name]}
                    helperText={errors[name]?.message ?? ""}
                    fullWidth
                    type={showPasswordToggle && showPassword ? "text" : "password"}
                    multiline={false}
                    rows={rows}
                    InputProps={inputProps}
                />
            )}
        />
    );
};